import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { API_BASE_URL } from "src/app/injection-constants";
import { CategoryItem } from "../models/category-item.model";
import { ServiceItem } from "../models/service-item.model";
import { CountryItem } from "../models/country-item.model";


@Injectable({
    providedIn: 'root',
})
export class LookupService {
    private servicesSource$: BehaviorSubject<ServiceItem[]> = new BehaviorSubject<ServiceItem[]>([]);
    private categoriesSource$: BehaviorSubject<CategoryItem[]> = new BehaviorSubject<CategoryItem[]>([]);
    private countriesSource$: BehaviorSubject<CountryItem[]> = new BehaviorSubject<CountryItem[]>([]);

    constructor(private readonly http: HttpClient,
        @Inject(API_BASE_URL) private readonly apiBaseUrl: string) {
        this.loadData();
    }

    getServices(): Observable<ServiceItem[]> {
        return this.servicesSource$;
    }

    getCategories(): Observable<CategoryItem[]> {
        return this.categoriesSource$;
    }

    getCountries(): Observable<CountryItem[]> {
        return this.countriesSource$;
    }

    private loadData(): void {
        this.http.get<ServiceItem[]>(`${this.apiBaseUrl}/lookup/services`).pipe(
            catchError(() => of([] as ServiceItem[])),
            tap(result => this.servicesSource$.next(result))
        ).subscribe();
        this.http.get<CategoryItem[]>(`${this.apiBaseUrl}/lookup/categories`).pipe(
            catchError(() => of([] as CategoryItem[])),
            tap(result => this.categoriesSource$.next(result))
        ).subscribe();
        this.http.get<CountryItem[]>(`${this.apiBaseUrl}/lookup/countries`).pipe(
            catchError(() => of([] as CountryItem[])),
            tap(result => this.countriesSource$.next(result))
        ).subscribe();
    }
}
